import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { QRCodeSVG } from 'qrcode.react'

const TestHzbankPay = () => {
  const [orderNo, setOrderNo] = useState('')
  const [qrCodeUrl, setQrCodeUrl] = useState('')
  const [qrCodeUrlAlt, setQrCodeUrlAlt] = useState('')
  const [weAliPaymentUrl, setWeAliPaymentUrl] = useState('')
  const [weAliPaymentUrlAlt, setWeAliPaymentUrlAlt] = useState('')
  const [status, setStatus] = useState('初始化')
  const [loading, setLoading] = useState(false)
  const [env, setEnv] = useState('sandbox')
  const navigate = useNavigate()

  const createOrder = async () => {
    setLoading(true)
    setStatus('正在创建订单...')
    try {
      const token = localStorage.getItem('token')
      const endpoint = env === 'prod' ? '/api/payment/test-hzbank-create-prod' : '/api/payment/test-hzbank-create'
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          amount: 0.02,
          subject: '充值测试0.02元'
        })
      })
      const data = await res.json()
      const isSuccess = res.ok && (data?.success === true || data?.status === 1)
      if (isSuccess) {
        setOrderNo(data.data?.orderNo || '')
        setQrCodeUrl(data.data?.qrCodeUrl || '')
        setQrCodeUrlAlt(data.data?.qrCodeUrlAlt || '')
        setWeAliPaymentUrl(data.data?.weAliPaymentUrl || '')
        setWeAliPaymentUrlAlt(data.data?.weAliPaymentUrlAlt || '')
        setStatus('订单创建成功，请扫码')
      } else {
        setStatus('创建失败: ' + (data?.error || data?.message || '未知错误'))
      }
    } catch (err) {
      setStatus('请求异常: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  const checkStatus = async () => {
    if (!orderNo) return
    setStatus('正在查询状态...')
    try {
      const token = localStorage.getItem('token')
      const res = await fetch(`/api/payment/status/${orderNo}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      const data = await res.json()
      const isSuccess = res.ok && (data?.success === true || data?.status === 1)
      if (isSuccess) {
        if (data.data?.isPaid) {
          setStatus('支付成功！')
        } else {
          setStatus('待支付')
        }
      } else {
        setStatus('查询失败: ' + (data?.error || data?.message || '未知错误'))
      }
    } catch (err) {
      setStatus('请求异常: ' + err.message)
    }
  }

  useEffect(() => {
    let timer
    if (orderNo && status !== '支付成功！') {
      timer = setInterval(() => {
        checkStatus()
      }, 3000)
    }
    return () => clearInterval(timer)
  }, [orderNo, status])

  const copyOrderNo = () => {
    if (orderNo) {
      navigator.clipboard.writeText(orderNo)
      alert('已复制订单号 (txId): ' + orderNo)
    }
  }

  return (
    <div style={{ padding: '40px', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <h2>杭州联合银行支付测试</h2>
      
      <div style={{ margin: '20px 0' }}>
        <label style={{ marginRight: '20px', cursor: 'pointer' }}>
          <input 
            type="radio" 
            value="sandbox" 
            checked={env === 'sandbox'} 
            onChange={(e) => setEnv(e.target.value)} 
          />
          沙盒测试环境 (apizsc)
        </label>
        <label style={{ cursor: 'pointer', color: 'red', fontWeight: 'bold' }}>
          <input 
            type="radio" 
            value="prod" 
            checked={env === 'prod'} 
            onChange={(e) => setEnv(e.target.value)} 
          />
          真实生产环境 (api.zj96596.com)
        </label>
      </div>

      <div style={{ margin: '20px 0' }}>
        <button 
          onClick={createOrder} 
          disabled={loading}
          style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', backgroundColor: env === 'prod' ? '#dc3545' : '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}
        >
          {loading ? '处理中...' : `生成0.02元订单 (${env === 'prod' ? '生产' : '测试'})`}
        </button>
      </div>

      <div style={{ margin: '20px 0', fontSize: '18px', fontWeight: 'bold', color: status === '支付成功！' ? 'green' : '#333' }}>
        状态: {status}
      </div>

      {orderNo && (
        <div style={{ margin: '15px auto', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', maxWidth: '400px' }}>
          <div style={{ color: '#495057', marginBottom: '8px' }}>订单号 (txId):</div>
          <div style={{ fontSize: '18px', fontWeight: 'bold', wordBreak: 'break-all', color: '#212529' }}>{orderNo}</div>
          <button 
            onClick={copyOrderNo}
            style={{ marginTop: '10px', padding: '5px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#e9ecef', border: '1px solid #ced4da', borderRadius: '4px' }}
          >
            点击复制订单号
          </button>
        </div>
      )}

      {qrCodeUrl && (
        <div style={{ marginTop: '30px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
          <p style={{ marginBottom: '15px' }}>请使用 <b>云闪付</b> 扫码（微信/支付宝可能提示“流水匹配异常”）</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px', justifyContent: 'center' }}>
            {[
              { label: '二维码1', url: qrCodeUrl },
              { label: '二维码2', url: qrCodeUrlAlt },
              { label: '二维码3', url: weAliPaymentUrl },
              { label: '二维码4', url: weAliPaymentUrlAlt }
            ]
              .filter(x => !!x.url)
              .map((item) => (
                <div key={item.label} style={{ width: '240px', padding: '12px', border: '1px solid #eee', borderRadius: '8px' }}>
                  <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>{item.label}</div>
                  <QRCodeSVG value={item.url} size={200} />
                  <div style={{ marginTop: '10px', fontSize: '12px', wordBreak: 'break-all', color: '#999' }}>
                    {item.url}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      <div style={{ marginTop: '40px' }}>
        <button onClick={() => navigate('/')} style={{ padding: '8px 15px' }}>返回首页</button>
      </div>
    </div>
  )
}

export default TestHzbankPay
